// fixme: falta agregar blogs, se supone que estan comentados pero falta hacerlos

import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import { useAuth } from "../Context/Context";

import Login from "../Views/Login";

// vistas generales
import Directorio from "../Views/Directorio/Directorio";
import Profesores from "../Views/Profesores/Profesores";
import Calendario from "../Views/Calendario/Calendario";
import Reinscripcion from "../Views/Reinscripcion/Reinscripcion";
import Titulacion from "../Views/Titulacion/Titulacion";
import Admision from "../Views/Admision/Aspirantes";
import Becas from '../Views/Beca/Becas';
import FAQs from "../Views/FAQs/Preguntas";

// Licenciaturas
import Licenciatura from "../Views/Licenciaturas/Licenciatura";

// Solicitudes de ingreso
import SolicitudReinscripcion from "../Views/Solicitudes/Solicitud_reinscripcion/SolicitudReinscripcion";
import SolicitudRein from "../Views/Solicitudes/Solicitud/Solicitud";
import SolicitudInscripcion from "../Views/Solicitudes/Solicitud_inscripcion/SolicitudInscripcion";
import SolicitudIns from "../Views/Solicitudes/Solicitud_ins/Solicitud";

// Reinscripciones
import ArchivosReinscripcion from "../Views/AllArchivos/ArchivosReinscripcion/ArchivosReinscripcion";

// Inscripciones
import ArchivosInscripcion from "../Views/AllArchivos/ArchivosInscripcion/ArchivosInscripcion";

// PDF's estudiantes
import Estudiantes from "../Views/Estudiantes/Estudiantes";
import PDF from "../Views/Estudiantes/PDF/PDF";
import AgregarPdf from "../Views/AgregarPdf/AgregarPdf";

// administradores
import Administradores from "../Views/Administradores/Administradores";
import EditarAdministrador from "../Views/Administradores/EditarAdministrador";

// cursos
import CursosGeneral from "../Views/Cursos/General";
import Cursos from "../Views/Cursos/Cursos";
import Curso from "../Views/Cursos/Curso/Curso";
import Etiquetas from "../Views/Etiquetas/Etiquetas";
import ProfesoresCursos from "../Views/ProfesoresCursos/ProfesoresCursos";

// autores blogs
import AutoresBlogs from "../Views/AutoresBlogs/AutoresBlogs";

// blogs
import Blogs from "../Views/Blogs/Blogs";
import Blog from "../Views/Blogs/Blog/Blog";
import EtiquetasBlogs from "../Views/EtiquetasBlogs/Etiquetas";

// baners
import Baners from "../Views/Baners/Baner";

// nuevos módulos
import Noticias from "../Views/Noticias/Noticias";
import AvisoInicio from "../Views/AvisoInicio/AvisoInicio";
import Mensajes from "../Views/Mensajes/Mensajes";

const RouterFunction = () => {
  const { recarga } = useAuth();

  return (
    <BrowserRouter>
      <div id="loader_padre" />
      <Routes key={recarga}>
        <Route path="/" element={<Login />} />

        {/* vistas */}
        <Route path="/directorio" element={<PrivateRoute><Directorio /></PrivateRoute>} />
        <Route path="/profesores" element={<PrivateRoute><Profesores /></PrivateRoute>} />
        <Route path="/calendario" element={<PrivateRoute><Calendario /></PrivateRoute>} />
        <Route path="/reinscripcion" element={<PrivateRoute><Reinscripcion /></PrivateRoute>} />
        <Route path="/titulaciones" element={<PrivateRoute><Titulacion /></PrivateRoute>} />
        <Route path="/becas" element={<PrivateRoute><Becas /></PrivateRoute>} />
        <Route path="/preguntas-frecuentes" element={<PrivateRoute><FAQs /></PrivateRoute>} />
        <Route path="/proceso-admision" element={<PrivateRoute><Admision /></PrivateRoute>} />

        {/* reinscripciones */}
        <Route
          path="/solicitud-reinscripciones"
          element={<PrivateRoute><SolicitudReinscripcion /></PrivateRoute>}
        />
        <Route
          path="/solicitud-reinscripcion/:id"
          element={<PrivateRoute><SolicitudRein /></PrivateRoute>}
        />
        <Route
          path="/solicitud-reinscripcion-archivado/:id"
          element={<PrivateRoute><SolicitudRein /></PrivateRoute>}
        />
        {/* archivados */}
        <Route
          path="/archivos-reinscripciones"
          element={<PrivateRoute><ArchivosReinscripcion /></PrivateRoute>}
        />

        {/* inscripciones */}
        <Route
          path="/solicitud-inscripciones"
          element={<PrivateRoute><SolicitudInscripcion /></PrivateRoute>}
        />
        <Route path="/solicitud-inscripcion/:id" element={<PrivateRoute><SolicitudIns /></PrivateRoute>} />
        <Route
          path="/solicitud-inscripcion-archivado/:id"
          element={<PrivateRoute><SolicitudIns /></PrivateRoute>}
        />
        {/* archivados */}
        <Route
          path="/archivos-inscripciones"
          element={<PrivateRoute><ArchivosInscripcion /></PrivateRoute>}
        />

        {/* PDFs estudiantes */}
        <Route path="/estudiantes" element={<PrivateRoute><Estudiantes /></PrivateRoute>} />
        <Route path="/estudiantes-pdf/:tipo" element={<PrivateRoute><PDF /></PrivateRoute>} />
        <Route path="/agregar-pdf/:tipo" element={<PrivateRoute><AgregarPdf /></PrivateRoute>} />

        {/* Administradores */}
        <Route path="/administradores" element={<PrivateRoute><Administradores /></PrivateRoute>} />
        <Route path="/administrador/:id" element={<PrivateRoute><EditarAdministrador /></PrivateRoute>} />

        {/* blogs */}
        <Route path="/blogs-noticias" element={<PrivateRoute><Blogs /></PrivateRoute>} />
        <Route path="/editar-blog/:id" element={<PrivateRoute><Blog /></PrivateRoute>} />
        <Route path="/etiquetas-blogs" element={<PrivateRoute><EtiquetasBlogs /></PrivateRoute>} />
        <Route path="/autores-blogs" element={<PrivateRoute><AutoresBlogs /></PrivateRoute>} />

        {/* cursos */}
        <Route path="/cursos-diplomados" element={<PrivateRoute><CursosGeneral /></PrivateRoute>} />
        <Route path="/profesores-cursos" element={<PrivateRoute><ProfesoresCursos /></PrivateRoute>} />
        <Route path="/cursos/:tipo" element={<PrivateRoute><Cursos /></PrivateRoute>} />
        <Route path="/curso/:id" element={<PrivateRoute><Curso /></PrivateRoute>} />
        <Route path="/etiquetas" element={<PrivateRoute><Etiquetas /></PrivateRoute>} />

        {/* baners */}
        <Route path="/baners" element={<PrivateRoute><Baners /></PrivateRoute>} />

        {/* nuevos módulos */}
        <Route path="/noticias" element={<PrivateRoute><Noticias /></PrivateRoute>} />
        <Route path="/aviso-inicio" element={<PrivateRoute><AvisoInicio /></PrivateRoute>} />
        <Route path="/mensajes" element={<PrivateRoute><Mensajes /></PrivateRoute>} />

        <Route path="/licenciaturas/:slug" element={<PrivateRoute><Licenciatura /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterFunction;
